import {LngKeys} from "@app/common/enums/lng-keys";
import {LngObj, LngTxtObj, RoutePaths, Routes_seo} from "@app/common/interfaces/route-paths";

/* Location countries code
  {
"BD": "Bangladesh",
"BE": "Belgium",
"BF": "Burkina Faso",
"BG": "Bulgaria",
"BA": "Bosnia and Herzegovina",
"BB": "Barbados",
"WF": "Wallis and Futuna",
"BL": "Saint Barthelemy",
"BM": "Bermuda",
"BN": "Brunei",
"BO": "Bolivia",
"BH": "Bahrain",
"BI": "Burundi",
"BJ": "Benin",
"BT": "Bhutan",
"JM": "Jamaica",
"BV": "Bouvet Island",
"BW": "Botswana",
"WS": "Samoa",
"BQ": "Bonaire, Saint Eustatius and Saba ",
"BR": "Brazil",
"BS": "Bahamas",
"JE": "Jersey",
"BY": "Belarus",
"BZ": "Belize",
"RU": "Russia",
"RW": "Rwanda",
"RS": "Serbia",
"TL": "East Timor",
"RE": "Reunion",
"TM": "Turkmenistan",
"TJ": "Tajikistan",
"RO": "Romania",
"TK": "Tokelau",
"GW": "Guinea-Bissau",
"GU": "Guam",
"GT": "Guatemala",
"GS": "South Georgia and the South Sandwich Islands",
"GR": "Greece",
"GQ": "Equatorial Guinea",
"GP": "Guadeloupe",
"JP": "Japan",
"GY": "Guyana",
"GG": "Guernsey",
"GF": "French Guiana",
"GE": "Georgia",
"GD": "Grenada",
"GB": "United Kingdom",
"GA": "Gabon",
"SV": "El Salvador",
"GN": "Guinea",
"GM": "Gambia",
"GL": "Greenland",
"GI": "Gibraltar",
"GH": "Ghana",
"OM": "Oman",
"TN": "Tunisia",
"JO": "Jordan",
"HR": "Croatia",
"HT": "Haiti",
"HU": "Hungary",
"HK": "Hong Kong",
"HN": "Honduras",
"HM": "Heard Island and McDonald Islands",
"VE": "Venezuela",
"PR": "Puerto Rico",
"PS": "Palestinian Territory",
"PW": "Palau",
"PT": "Portugal",
"SJ": "Svalbard and Jan Mayen",
"PY": "Paraguay",
"IQ": "Iraq",
"PA": "Panama",
"PF": "French Polynesia",
"PG": "Papua New Guinea",
"PE": "Peru",
"PK": "Pakistan",
"PH": "Philippines",
"PN": "Pitcairn",
"PL": "Poland",
"PM": "Saint Pierre and Miquelon",
"ZM": "Zambia",
"EH": "Western Sahara",
"EE": "Estonia",
"EG": "Egypt",
"ZA": "South Africa",
"EC": "Ecuador",
"IT": "Italy",
"VN": "Vietnam",
"SB": "Solomon Islands",
"ET": "Ethiopia",
"SO": "Somalia",
"ZW": "Zimbabwe",
"SA": "Saudi Arabia",
"ES": "Spain",
"ER": "Eritrea",
"ME": "Montenegro",
"MD": "Moldova",
"MG": "Madagascar",
"MF": "Saint Martin",
"MA": "Morocco",
"MC": "Monaco",
"UZ": "Uzbekistan",
"MM": "Myanmar",
"ML": "Mali",
"MO": "Macao",
"MN": "Mongolia",
"MH": "Marshall Islands",
"MK": "Macedonia",
"MU": "Mauritius",
"MT": "Malta",
"MW": "Malawi",
"MV": "Maldives",
"MQ": "Martinique",
"MP": "Northern Mariana Islands",
"MS": "Montserrat",
"MR": "Mauritania",
"IM": "Isle of Man",
"UG": "Uganda",
"TZ": "Tanzania",
"MY": "Malaysia",
"MX": "Mexico",
"IL": "Israel",
"FR": "France",
"IO": "British Indian Ocean Territory",
"SH": "Saint Helena",
"FI": "Finland",
"FJ": "Fiji",
"FK": "Falkland Islands",
"FM": "Micronesia",
"FO": "Faroe Islands",
"NI": "Nicaragua",
"NL": "Netherlands",
"NO": "Norway",
"NA": "Namibia",
"VU": "Vanuatu",
"NC": "New Caledonia",
"NE": "Niger",
"NF": "Norfolk Island",
"NG": "Nigeria",
"NZ": "New Zealand",
"NP": "Nepal",
"NR": "Nauru",
"NU": "Niue",
"CK": "Cook Islands",
"XK": "Kosovo",
"CI": "Ivory Coast",
"CH": "Switzerland",
"CO": "Colombia",
"CN": "China",
"CM": "Cameroon",
"CL": "Chile",
"CC": "Cocos Islands",
"CA": "Canada",
"CG": "Republic of the Congo",
"CF": "Central African Republic",
"CD": "Democratic Republic of the Congo",
"CZ": "Czech Republic",
"CY": "Cyprus",
"CX": "Christmas Island",
"CR": "Costa Rica",
"CW": "Curacao",
"CV": "Cape Verde",
"CU": "Cuba",
"SZ": "Swaziland",
"SY": "Syria",
"SX": "Sint Maarten",
"KG": "Kyrgyzstan",
"KE": "Kenya",
"SS": "South Sudan",
"SR": "Suriname",
"KI": "Kiribati",
"KH": "Cambodia",
"KN": "Saint Kitts and Nevis",
"KM": "Comoros",
"ST": "Sao Tome and Principe",
"SK": "Slovakia",
"KR": "South Korea",
"SI": "Slovenia",
"KP": "North Korea",
"KW": "Kuwait",
"SN": "Senegal",
"SM": "San Marino",
"SL": "Sierra Leone",
"SC": "Seychelles",
"KZ": "Kazakhstan",
"KY": "Cayman Islands",
"SG": "Singapore",
"SE": "Sweden",
"SD": "Sudan",
"DO": "Dominican Republic",
"DM": "Dominica",
"DJ": "Djibouti",
"DK": "Denmark",
"VG": "British Virgin Islands",
"DE": "Germany",
"YE": "Yemen",
"DZ": "Algeria",
"US": "United States",
"UY": "Uruguay",
"YT": "Mayotte",
"UM": "United States Minor Outlying Islands",
"LB": "Lebanon",
"LC": "Saint Lucia",
"LA": "Laos",
"TV": "Tuvalu",
"TW": "Taiwan",
"TT": "Trinidad and Tobago",
"TR": "Turkey",
"LK": "Sri Lanka",
"LI": "Liechtenstein",
"LV": "Latvia",
"TO": "Tonga",
"LT": "Lithuania",
"LU": "Luxembourg",
"LR": "Liberia",
"LS": "Lesotho",
"TH": "Thailand",
"TF": "French Southern Territories",
"TG": "Togo",
"TD": "Chad",
"TC": "Turks and Caicos Islands",
"LY": "Libya",
"VA": "Vatican",
"VC": "Saint Vincent and the Grenadines",
"AE": "United Arab Emirates",
"AD": "Andorra",
"AG": "Antigua and Barbuda",
"AF": "Afghanistan",
"AI": "Anguilla",
"VI": "U.S. Virgin Islands",
"IS": "Iceland",
"IR": "Iran",
"AM": "Armenia",
"AL": "Albania",
"AO": "Angola",
"AQ": "Antarctica",
"AS": "American Samoa",
"AR": "Argentina",
"AU": "Australia",
"AT": "Austria",
"AW": "Aruba",
"IN": "India",
"AX": "Aland Islands",
"AZ": "Azerbaijan",
"IE": "Ireland",
"ID": "Indonesia",
"UA": "Ukraine",
"QA": "Qatar",
"MZ": "Mozambique"
}
* */

interface LngKeyCode {
  country: string;
  keyCode: string;
}

export const EURO_CURRENCY_COUNTRIES: Readonly<LngKeyCode[]> = [
  {country: "Belgium", keyCode: "BE"},
  {country: "Germany", keyCode: "DE"},
  {country: "Estonia", keyCode: "EE"},
  {country: "Ireland", keyCode: "IE"},
  {country: "Greece", keyCode: "GR"},
  {country: "Spain", keyCode: "ES"},
  {country: "France", keyCode: "FR"},
  {country: "Italy", keyCode: "IT"},
  {country: "Cyprus", keyCode: "CY"},
  {country: "Latvia", keyCode: "LV"},
  {country: "Lithuania", keyCode: "LT"},
  {country: "Luxembourg", keyCode: "LU"},
  {country: "Malta", keyCode: "MT"},
  {country: "Netherlands", keyCode: "NL"},
  {country: "Austria", keyCode: "AT"},
  {country: "Portugal", keyCode: "PT"},
  {country: "Slovenia", keyCode: "SI"},
  {country: "Slovakia", keyCode: "SK"},
  {country: "Croatia", keyCode: "HR"}
];

export const FRENCH_SPEAKING_COUNTRIES: Readonly<LngKeyCode[]> = [
  {country: "Belgium", keyCode: "BE"},
  {country: "Benin", keyCode: "BJ"},
  {country: "Burkina Faso", keyCode: "BF"},
  {country: "Burundi", keyCode: "BI"},
  {country: "Cameroon", keyCode: "CM"},
  // { country: "Canada", keyCode: "CA" },
  {country: "Central African Republic", keyCode: "CF"},
  {country: "Chad", keyCode: "TD"},
  {country: "Comoros", keyCode: "KM"}, // Also Arabic
  {country: "Congo", keyCode: "CG"},
  {country: "Democratic Republic of the Congo", keyCode: "CD"},
  {country: "Ivory Coast", keyCode: "CI"},
  {country: "Djibouti", keyCode: "DJ"}, // Also Arabic
  // {country: "Equatorial Guinea", keyCode: "GQ"}, // Also Spanish
  {country: "France", keyCode: "FR"},
  {country: "Gabon", keyCode: "GA"},
  {country: "Guinea", keyCode: "GN"},
  {country: "Haiti", keyCode: "HT"},
  {country: "Luxembourg", keyCode: "LU"},
  {country: "Madagascar", keyCode: "MG"},
  {country: "Mali", keyCode: "ML"},
  {country: "Monaco", keyCode: "MC"},
  {country: "Niger", keyCode: "NE"},
  {country: "Rwanda", keyCode: "RW"},
  {country: "Senegal", keyCode: "SN"},
  {country: "Seychelles", keyCode: "SC"},
  // {country: "Switzerland", keyCode: "CH"}, // Also German
  {country: "Togo", keyCode: "TG"},
  {country: "Vanuatu", keyCode: "VU"}
];

export const GERMAN_SPEAKING_COUNTRIES: Readonly<LngKeyCode[]> = [
  {country: "Germany", keyCode: "DE"},
  {country: "Austria", keyCode: "AT"},
  {country: "Switzerland", keyCode: "CH"}, // Also French
  // { country: "Belgium", keyCode: "BE" }, // Also French
  // { country: "Luxembourg", keyCode: "LU" }, // Also French
  {country: "Liechtenstein", keyCode: "LI"}
];

export const SPANISH_SPEAKING_COUNTRIES: Readonly<LngKeyCode[]> = [
  {country: "Argentina", keyCode: "AR"},
  {country: "Bolivia", keyCode: "BO"},
  {country: "Chile", keyCode: "CL"},
  {country: "Colombia", keyCode: "CO"},
  {country: "Costa Rica", keyCode: "CR"},
  {country: "Cuba", keyCode: "CU"},
  {country: "Dominican Republic", keyCode: "DO"},
  {country: "Ecuador", keyCode: "EC"},
  {country: "El Salvador", keyCode: "SV"},
  {country: "Equatorial Guinea", keyCode: "GQ"},
  {country: "Guatemala", keyCode: "GT"},
  {country: "Honduras", keyCode: "HN"},
  {country: "Mexico", keyCode: "MX"},
  {country: "Nicaragua", keyCode: "NI"},
  {country: "Panama", keyCode: "PA"},
  {country: "Paraguay", keyCode: "PY"},
  {country: "Peru", keyCode: "PE"},
  {country: "Spain", keyCode: "ES"},
  {country: "Uruguay", keyCode: "UY"},
  {country: "Venezuela", keyCode: "VE"}
];

export const PORTUGUESE_SPEAKING_COUNTRIES: Readonly<LngKeyCode[]> = [
  {country: "Angola", keyCode: "AO"},
  {country: "Brazil", keyCode: "BR"},
  {country: "Cape Verde", keyCode: "CV"},
  {country: "East Timor", keyCode: "TL"},
  // {country: "Equatorial Guinea", keyCode: "GQ"}, // ALso Spanish and French
  {country: "Guinea-Bissau", keyCode: "GW"},
  {country: "Mozambique", keyCode: "MZ"},
  {country: "Portugal", keyCode: "PT"},
  {country: "Sao Tome and Principe", keyCode: "ST"}
];

export const ARABIC_SPEAKING_COUNTRIES: Readonly<LngKeyCode[]> = [
  {country: "Algeria", keyCode: "DZ"},
  {country: "Bahrain", keyCode: "BH"},
  {country: "Comoros", keyCode: "KM"},
  {country: "Djibouti", keyCode: "DJ"},
  {country: "Egypt", keyCode: "EG"},
  {country: "Iraq", keyCode: "IQ"},
  {country: "Jordan", keyCode: "JO"},
  {country: "Kuwait", keyCode: "KW"},
  {country: "Lebanon", keyCode: "LB"},
  {country: "Libya", keyCode: "LY"},
  {country: "Mauritania", keyCode: "MR"},
  {country: "Morocco", keyCode: "MA"},
  {country: "Oman", keyCode: "OM"},
  {country: "Palestine", keyCode: "PS"},
  {country: "Qatar", keyCode: "QA"},
  {country: "Saudi Arabia", keyCode: "SA"},
  {country: "Somalia", keyCode: "SO"},
  {country: "Sudan", keyCode: "SD"},
  {country: "Syria", keyCode: "SY"},
  {country: "Tunisia", keyCode: "TN"},
  {country: "United Arab Emirates", keyCode: "AE"},
  {country: "Yemen", keyCode: "YE"}
];

export const CHINESE_SPEAKING_COUNTRIES: Readonly<LngKeyCode[]> = [
  {country: "China", keyCode: "CN"},
  {country: "Taiwan", keyCode: "TW"},
  {country: "Singapore", keyCode: "SG"},
  {country: "Hong Kong", keyCode: "HK"},
  {country: "Macau", keyCode: "MO"}
];

/* --------------------------- */

export const LANGUAGES_OBJ: Readonly<LngObj> = {
  [LngKeys.EN]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/en.svg" alt="selfcv">English</div>`,
    key: LngKeys.EN,
    direction: 'ltr',
    fName: 'English',
    href: 'https://www.selfcv.com',
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, armenia, tours in armenia, private tours, tours in Armenia, tours, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. Book tour online!`,
      og: {
        local: `en`,
      }
    }
  },
  [LngKeys.RU]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/ru.svg" alt="selfcv">Русский</div>`,
    key: LngKeys.RU,
    direction: 'ltr',
    fName: 'Русский',
    href: `https://www.selfcv.com/${LngKeys.RU}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Армения, туры в Армении, частные туры, путешествия по Армении, туры, Гарни, Гегард, Севан, Дилижан, Хор Вирап, Татев, Эчмиадзин. Забронируйте тур онлайн!`,
      og: {
        local: "ru"
      }
    }
  },


/*  [LngKeys.FR]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/fr.svg" alt="selfcv">Français</div>`,
    key: LngKeys.FR,
    direction: 'ltr',
    fName: 'Français',
    href: `https://www.selfcv.com/${LngKeys.FR}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Arménie, circuits en Arménie, visites privées, voyages en Arménie, circuits, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Etchmiadzin. Réservez votre circuit en ligne !`,
      og: {
        local: `fr`,
      }
    },
  },
  [LngKeys.DE]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/de.svg" alt="selfcv">Deutsch</div>`,
    key: LngKeys.DE,
    direction: 'ltr',
    fName: 'Deutsch',
    href: `https://www.selfcv.com/${LngKeys.DE}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenien, Touren in Armenien, private Touren, Reisen in Armenien, Touren, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Etschmiadsin. Tour online buchen!`,
      og: {
        local: `de`,
      }
    },
  },
  [LngKeys.ES]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/es.svg" alt="selfcv">Español</div>`,
    key: LngKeys.ES,
    direction: 'ltr',
    fName: 'Español',
    href: `https://www.selfcv.com/${LngKeys.ES}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenia, tours en Armenia, tours privados, viajes en Armenia, tours, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. Reserva el tour en línea!`,
      og: {
        local: `es`,
      }
    },
  },
  [LngKeys.HI]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/indi.svg" alt="selfcv">हिन्दी</div>`,
    key: LngKeys.HI,
    direction: 'ltr',
    fName: 'हिन्दी',
    href: `https://www.selfcv.com/${LngKeys.HI}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, आर्मेनिया, आर्मेनिया में टूर, निजी टूर, आर्मेनिया में यात्राएं, टूर, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. ऑनलाइन टूर बुक करें!`,
      og: {
        local: `hi`,
      }
    },
  },
  [LngKeys.TR]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/tr.svg" alt="selfcv">Türkçe</div>`,
    key: LngKeys.TR,
    direction: 'ltr',
    fName: 'Türkçe',
    href: `https://www.selfcv.com/${LngKeys.TR}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Ermenistan, Ermenistan turları, özel turlar, Ermenistan gezileri, turlar, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Eçmiadzin. Turu online rezerve edin!`,
      og: {
        local: `tr`,
      }
    }
  },
  [LngKeys.IT]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/it.svg" alt="selfcv">Italiano</div>`,
    key: LngKeys.IT,
    direction: 'ltr',
    fName: 'Italiano',
    href: `https://www.selfcv.com/${LngKeys.IT}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenia, tour in Armenia, tour privati, viaggi in Armenia, tour, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. Prenota il tour online!`,
      og: {
        local: `it`,
      }
    },
  },
  [LngKeys.PT]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/pt.png" alt="selfcv">Português</div>`,
    key: LngKeys.PT,
    direction: 'ltr',
    fName: 'Português',
    href: `https://www.selfcv.com/${LngKeys.PT}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armênia, tours na Armênia, tours privados, viagens na Armênia, tours, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. Reserve o tour online!`,
      og: {
        local: `pt`,
      }
    },
  },
  [LngKeys.ZH]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/zh.svg" alt="selfcv">中文</div>`,
    key: LngKeys.ZH,
    direction: 'ltr',
    fName: '中文',
    href: `https://www.selfcv.com/${LngKeys.ZH}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, 亚美尼亚, 亚美尼亚旅游, 私人旅游, 亚美尼亚旅行, 旅游, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. 在线预订旅游!`,
      og: {
        local: `cn`,
      }
    },
  },
  [LngKeys.JA]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/ja.png" alt="selfcv">日本語</div>`,
    key: LngKeys.JA,
    direction: 'ltr',
    fName: '日本語',
    href: `https://www.selfcv.com/${LngKeys.JA}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, アルメニア, アルメニアツアー, プライベートツアー, アルメニア旅行, ツアー, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. オンラインでツアーを予約!`,
      og: {
        local: `ja`,
      }
    },
  },
  [LngKeys.PL]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/pl.webp" alt="selfcv">Polski</div>`,
    key: LngKeys.PL,
    direction: 'ltr',
    fName: 'Polski',
    href: `https://www.selfcv.com/${LngKeys.PL}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenia, wycieczki po Armenii, prywatne wycieczki, podróże po Armenii, wycieczki, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Eczmiadzyn. Zarezerwuj wycieczkę online!`,
      og: {
        local: `pl`,
      }
    },
  },
  [LngKeys.SV]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/sv.png" alt="selfcv">Svenska</div>`,
    key: LngKeys.SV,
    direction: 'ltr',
    fName: 'Svenska',
    href: `https://www.selfcv.com/${LngKeys.SV}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenien, turer i Armenien, privata turer, resor i Armenien, turer, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Etjmiadzin. Boka tur online!`,
      og: {
        local: `sv-SE`,
      }
    },
  },
  [LngKeys.NL]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/nl.png" alt="selfcv">Nederlands</div>`,
    key: LngKeys.NL,
    direction: 'ltr',
    fName: 'Nederlands',
    href: `https://www.selfcv.com/${LngKeys.NL}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenië, tours in Armenië, privétours, reizen in Armenië, tours, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Etsjmiadzin. Boek tour online!`,
      og: {
        local: `nl`,
      }
    },
  },
  [LngKeys.AR]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/ar.png" alt="selfcv">العربية</div>`,
    key: LngKeys.AR,
    direction: 'rtl',
    fName: 'العربية',
    href: `https://www.selfcv.com/${LngKeys.AR}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia، أرمينيا، جولات في أرمينيا، جولات خاصة، رحلات في أرمينيا، جولات، Garni، Geghard، Sevan، Dilijan، Khor Virap، Tatev، Echmiadzin. احجز الجولة عبر الإنترنت!`,
      og: {
        local: `ar`,
      }
    },
  },
  [LngKeys.NB]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/nb.webp" alt="selfcv">Norsk</div>`,
    key: LngKeys.NB,
    direction: 'ltr',
    fName: 'Norsk',
    href: `https://www.selfcv.com/${LngKeys.NB}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenia, turer i Armenia, private turer, reiser i Armenia, turer, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Etsjmiadzin. Bestill tur online!`,
      og: {
        local: `nb_NO`,
      }
    },
  },
  [LngKeys.FI]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/fi.webp" alt="selfcv">Suomi</div>`,
    key: LngKeys.FI,
    direction: 'ltr',
    fName: 'Suomi',
    href: `https://www.selfcv.com/${LngKeys.FI}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenia, retket Armeniassa, yksityiset retket, matkat Armeniassa, retket, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Etshmiadzin. Varaa retki verkossa!`,
      og: {
        local: `fi_FI`,
      }
    },
  },
  [LngKeys.CS]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/cs.png" alt="selfcv">Čeština</div>`,
    key: LngKeys.CS,
    direction: 'ltr',
    fName: 'Čeština',
    href: `https://www.selfcv.com/${LngKeys.CS}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Arménie, zájezdy v Arménii, soukromé zájezdy, cesty po Arménii, zájezdy, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Ečmiadzin. Rezervujte zájezd online!`,
      og: {
        local: `cs_CZ`,
      }
    },
  },
  [LngKeys.DA]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/da.png" alt="selfcv">Dansk</div>`,
    key: LngKeys.DA,
    direction: 'ltr',
    fName: 'Dansk',
    href: `https://www.selfcv.com/${LngKeys.DA}`,
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenien, ture i Armenien, private ture, rejser i Armenien, ture, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Etjmiadzin. Book tur online!`,
      og: {
        local: `da_DK`,
      }
    }
  },
  [LngKeys.EL]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/el.jpeg" alt="selfcv">Ελληνικά</div>`,
    key: LngKeys.EL,
    direction: 'ltr',
    fName: 'Ελληνικά',
    href: 'https://www.selfcv.com/el',
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Αρμενία, εκδρομές στην Αρμενία, ιδιωτικές εκδρομές, ταξίδια στην Αρμενία, εκδρομές, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. Κλείστε εκδρομή online!`,
      og: {
        local: `el`,
      }
    }
  },
  [LngKeys.RO]: {
    name: `<div class="sf-lng-item"><img src="/assets/img/languages/ro.jpg" alt="selfcv">Română</div>`,
    key: LngKeys.RO,
    direction: 'ltr',
    fName: 'Română',
    href: 'https://www.selfcv.com/ro',
    seo: {
      keywords: `tourdearmenia, Tour de Armenia, Armenia, tururi în Armenia, tururi private, călătorii în Armenia, tururi, Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Ecimiadzin. Rezervă turul online!`,
      og: {
        local: `ro`,
      }
    }
  },*/
};

export const lngTxtObj: Readonly<LngTxtObj> = {
  en: {
    txt: 'Continue on English?',
    lng: LngKeys.EN
  },
  ru: {
    txt: 'Продолжить на Русском?',
    lng: LngKeys.RU
  },

  /*fr: {
    txt: 'Continuer en Français?',
    lng: LngKeys.FR
  },
  de: {
    txt: 'Auf Deutsch fortfahren?',
    lng: LngKeys.DE
  },
  es: {
    txt: '¿Continuar en Español?',
    lng: LngKeys.ES
  },
  hi: {
    txt: 'हिंदी में जारी रखें?',
    lng: LngKeys.HI
  },
  tr: {
    txt: 'Türkçe devam etmek ister misiniz?',
    lng: LngKeys.TR
  },
  it: {
    txt: 'Continuare in Italiano?',
    lng: LngKeys.IT
  },
  pt: {
    txt: 'Continuar em Português?',
    lng: LngKeys.PT
  },
  zh: {
    txt: '继续使用中文？',
    lng: LngKeys.ZH
  },
  ja: {
    txt: '英語で続けますか？',
    lng: LngKeys.JA
  },
  pl: {
    txt: 'Kontynuować po polsku?',
    lng: LngKeys.PL
  },
  sv: {
    txt: 'Fortsätta på svenska?',
    lng: LngKeys.SV
  },
  nl: {
    txt: 'Doorgaan in het Nederlands?',
    lng: LngKeys.NL
  },
  ar: {
    txt: 'هل تريد المتابعة باللغة العربية؟',
    lng: LngKeys.AR
  },
  nb: {
    txt: 'Fortsette på norsk?',
    lng: LngKeys.NB
  },
  fi: {
    txt: 'Jatketaanko suomeksi?',
    lng: LngKeys.FI
  },
  cs: {
    txt: 'Pokračovat v češtině?',
    lng: LngKeys.CS
  },
  da: {
    txt: 'Fortsætte på dansk?',
    lng: LngKeys.DA
  },
  el: {
    txt: 'Συνέχεια στα Ελληνικά;',
    lng: LngKeys.EL
  },
  ro: {
    txt: 'Continuați în română?',
    lng: LngKeys.RO
  },*/
};

export const route_paths: Readonly<RoutePaths> = {
  [LngKeys.EN]: {home: '/'},
  [LngKeys.RU]: {home: '/ru'},

/*  [LngKeys.FR]: {home: '/fr'},
  [LngKeys.DE]: {home: '/de'},
  [LngKeys.ES]: {home: '/es'},
  [LngKeys.SV]: {home: '/sv'},
  [LngKeys.PT]: {home: '/pt'},
  [LngKeys.IT]: {home: '/it'},
  [LngKeys.NB]: {home: '/nb'},
  [LngKeys.NL]: {home: '/nl'},
  [LngKeys.FI]: {home: '/fi'},
  [LngKeys.CS]: {home: '/cs'},
  [LngKeys.PL]: {home: '/pl'},
  [LngKeys.DA]: {home: '/da'},
  [LngKeys.EL]: {home: '/el'},
  [LngKeys.RO]: {home: '/ro'},
  [LngKeys.HI]: {home: '/hi'},
  [LngKeys.TR]: {home: '/tr'},
  [LngKeys.ZH]: {home: '/zh'},
  [LngKeys.JA]: {home: '/ja'},
  [LngKeys.AR]: {home: '/ar'},*/
};

export const routes_seo: Readonly<Routes_seo> = {
  [LngKeys.EN]: {
    home: {
      title: 'Tour de Armenia | Private tours in Armenia',
      description: 'Tour de Armenia offers private tours in Armenia to the most popular destinations like Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev, Echmiadzin. Book your tour online!'
    }
  },
  [LngKeys.RU]: {
    home: {
      title: 'Tour de Armenia | Частные туры в Армении',
      description: 'Tour de Armenia предлагает частные туры в Армении по самым популярным направлениям, таким как Гарни, Гегард, Севан, Дилижан, Хор Вирап, Татев и Эчмиадзин. Забронируйте тур онлайн!'
    }
  },

/*  [LngKeys.FR]: {
    home: {
      title: "Tour de Armenia | Visites privées en Arménie",
      description: "Tour de Armenia propose des visites privées en Arménie vers les destinations les plus populaires comme Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev et Etchmiadzin. Réservez votre circuit en ligne !",
    }
  },
  [LngKeys.DE]: {
    home: {
      title: "Tour de Armenia | Private Touren in Armenien",
      description: "Tour de Armenia bietet private Touren in Armenien zu den beliebtesten Reisezielen wie Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev und Etschmiadsin. Tour online buchen!",
    }
  },
  [LngKeys.ES]: {
    home: {
      title: 'Tour de Armenia | Tours privados en Armenia',
      description: 'Tour de Armenia ofrece tours privados en Armenia a los destinos más populares como Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev y Echmiadzin. Reserva tu tour en línea!'
    }
  },
  [LngKeys.SV]: {
    home: {
      title: 'Tour de Armenia | Privata turer i Armenien',
      description: 'Tour de Armenia erbjuder privata turer i Armenien till de mest populära destinationerna som Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev och Etjmiadzin. Boka din tur online!'
    }
  },
  [LngKeys.PT]: {
    home: {
      title: 'Tour de Armenia | Tours privados na Armênia',
      description: 'A Tour de Armenia oferece tours privados na Armênia para os destinos mais populares, como Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev e Echmiadzin. Reserve seu tour online!'
    }
  },
  [LngKeys.IT]: {
    home: {
      title: 'Tour de Armenia | Tour privati in Armenia',
      description: 'Tour de Armenia offre tour privati in Armenia verso le destinazioni più popolari come Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev ed Echmiadzin. Prenota il tuo tour online!'
    }
  },
  [LngKeys.NB]: {
    home: {
      title: 'Tour de Armenia | Private turer i Armenia',
      description: 'Tour de Armenia tilbyr private turer i Armenia til de mest populære reisemålene som Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev og Etsjmiadzin. Bestill turen din online!'
    }
  },
  [LngKeys.NL]: {
    home: {
      title: 'Tour de Armenia | Privétours in Armenië',
      description: 'Tour de Armenia biedt privétours in Armenië naar de populairste bestemmingen zoals Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev en Etsjmiadzin. Boek je tour online!'
    }
  },
  [LngKeys.FI]: {
    home: {
      title: 'Tour de Armenia | Yksityiset retket Armeniassa',
      description: 'Tour de Armenia tarjoaa yksityisiä retkiä Armeniassa suosituimpiin kohteisiin, kuten Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev ja Etshmiadzin. Varaa retkesi verkossa!'
    }
  },
  [LngKeys.CS]: {
    home: {
      title: 'Tour de Armenia | Soukromé zájezdy v Arménii',
      description: 'Tour de Armenia nabízí soukromé zájezdy v Arménii do nejoblíbenějších destinací, jako jsou Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev a Ečmiadzin. Rezervujte si zájezd online!'
    }
  },
  [LngKeys.PL]: {
    home: {
      title: 'Tour de Armenia | Prywatne wycieczki po Armenii',
      description: 'Tour de Armenia oferuje prywatne wycieczki po Armenii do najpopularniejszych miejsc, takich jak Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev i Eczmiadzyn. Zarezerwuj wycieczkę online!'
    }
  },
  [LngKeys.DA]: {
    home: {
      title: 'Tour de Armenia | Private ture i Armenien',
      description: 'Tour de Armenia tilbyder private ture i Armenien til de mest populære destinationer som Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev og Etjmiadzin. Book din tur online!'
    }
  },
  [LngKeys.EL]: {
    home: {
      title: 'Tour de Armenia | Ιδιωτικές εκδρομές στην Αρμενία',
      description: 'Το Tour de Armenia προσφέρει ιδιωτικές εκδρομές στην Αρμενία στους πιο δημοφιλείς προορισμούς, όπως Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev και Echmiadzin. Κλείστε την εκδρομή σας online!'
    }
  },
  [LngKeys.RO]: {
    home: {
      title: 'Tour de Armenia | Tururi private în Armenia',
      description: 'Tour de Armenia oferă tururi private în Armenia către cele mai populare destinații, precum Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev și Ecimiadzin. Rezervă turul online!'
    }
  },
  [LngKeys.HI]: {
    home: {
      title: "Tour de Armenia | आर्मेनिया में निजी टूर",
      description: "Tour de Armenia आर्मेनिया में Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev और Echmiadzin जैसे सबसे लोकप्रिय स्थलों के लिए निजी टूर प्रदान करता है। अपना टूर ऑनलाइन बुक करें!"
    }
  },
  [LngKeys.TR]: {
    home: {
      title: 'Tour de Armenia | Ermenistan’da özel turlar',
      description: 'Tour de Armenia, Ermenistan’da Garni, Geghard, Sevan, Dilijan, Khor Virap, Tatev ve Eçmiadzin gibi en popüler destinasyonlara özel turlar sunar. Turunuzu online rezerve edin!'
    }
  },
  [LngKeys.ZH]: {
    home: {
      title: "Tour de Armenia | 亚美尼亚私人旅游",
      description: "Tour de Armenia 提供亚美尼亚私人旅游，前往 Garni、Geghard、Sevan、Dilijan、Khor Virap、Tatev 和 Echmiadzin 等热门目的地。在线预订您的旅游!"
    }
  },
  [LngKeys.JA]: {
    home: {
      title: 'Tour de Armenia | アルメニアのプライベートツアー',
      description: 'Tour de Armeniaは、Garni、Geghard、Sevan、Dilijan、Khor Virap、Tatev、Echmiadzinなど人気の目的地へのアルメニアのプライベートツアーを提供しています。オンラインでツアーを予約!'
    }
  },
  [LngKeys.AR]: {
    home: {
      title: "Tour de Armenia | جولات خاصة في أرمينيا",
      description: "تقدم Tour de Armenia جولات خاصة في أرمينيا إلى أشهر الوجهات مثل Garni وGeghard وSevan وDilijan وKhor Virap وTatev وEchmiadzin. احجز جولتك عبر الإنترنت!"
    }
  },*/
};

